import type { Product } from '../wysiwyg/packageUtils';

type ProductActivityCandidate = {
  active?: unknown;
  isArchived?: unknown;
  status?: unknown;
  Status?: unknown;
};

export function isActiveProduct(product: unknown): boolean {
  if (!product || typeof product !== 'object' || Array.isArray(product)) return false;
  const candidate = product as ProductActivityCandidate;
  if (candidate.isArchived === true) return false;
  if (candidate.active === false) return false;
  const status = String(candidate.status || candidate.Status || '').toLowerCase();
  if (status === 'archived' || status === 'inactive') return false;
  if (candidate.active === true) return true;
  if (status) return status === 'active';
  return true;
}

export function getActiveProductOptions(products: Product[]) {
  return getProductOptions(products, false);
}

export function getProductOptions(products: Product[], includeArchived: boolean) {
  const options = new Map<number, { name: string; active: boolean }>();
  products
    .filter((product) => includeArchived || isActiveProduct(product))
    .forEach((product) => {
      if (product.name && Number.isFinite(product.id) && product.id > 0) {
        const active = isActiveProduct(product);
        const current = options.get(product.id);
        if (!current || (!current.active && active)) {
          options.set(product.id, { name: product.name, active });
        }
      }
    });

  return Array.from(options.entries())
    .map(([id, option]) => ({ id, name: option.name, active: option.active }))
    .sort((a, b) => {
      const byActive = Number(b.active) - Number(a.active);
      if (byActive !== 0) return byActive;
      const byName = a.name.localeCompare(b.name);
      if (byName !== 0) return byName;
      return a.id - b.id;
    })
    .map(({ id, name }) => ({ id, name }));
}

export function getActiveProductOverride(products: Product[], productOverrideId: number | null) {
  return getProductOverride(products, productOverrideId, false);
}

export function getProductOverride(
  products: Product[],
  productOverrideId: number | null,
  includeArchived: boolean,
) {
  if (productOverrideId == null) return null;
  return products.find((product) => (
    product.id === productOverrideId && (includeArchived || isActiveProduct(product))
  )) || null;
}
